$tabsControls = $ '[data-for]'

if $tabsControls.length > 0
	$tabsControls.on 'click', ->
		$this = $ this
		forId = $this.data 'for'
		idName = '#' + forId
		$relatedElement = $ idName
		relatedIsVisible = $relatedElement.is ':visible'
		return if relatedIsVisible
		relatedClass = $relatedElement.attr 'class'

		$relatedParent = $relatedElement.parent()
		$relatedChildrens = $relatedParent.find '.' + relatedClass

		$relatedChildrens.fadeOut 300, ->
			$relatedChildrens.removeClass 'is-active'
		$relatedElement.fadeIn 300, ->
			$relatedElement.addClass 'is-active'
		.css 'display', 'inline-block'


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/tabs.coffee
 **/